// extracted by mini-css-extract-plugin
module.exports = {"root":"_5f554b","itemCard":"_8c03a8","pagination":"_3548b2"};